import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { ThemeContext } from 'utils/theme';
import AwardCounterModel from 'models/AwardCounter';

import Wrapper from './styled/Wrapper';
import Heading from './styled/Heading';
import Title from './styled/Title';
import Paragraph1 from './styled/Paragraph1';
import Paragraph2 from './styled/Paragraph2';
import AwardsWrapper from './styled/AwardsWrapper';
import AwardCounter from './styled/AwardCounter';
import TextWrapper from './styled/TextWrapper';
import Header from './styled/Header';
import Article from './styled/Article';

export default class RecognitionSection extends PureComponent {

  static defaultProps = {};

  static contextType = ThemeContext;

  render() {
    const { className, heading, title, paragraph1, paragraph2, awards ,childRef} = this.props;

    // For medium screens, make sure the biggest number is in the center.
    const sorted = awards.sort((a, b) => a.count - b.count);
    const top = sorted[sorted.length - 1];
    const awardsSorted = awards.filter(a => a.name !== top.name);
    awardsSorted.splice(1, 0, top);

    return (
      <Wrapper ref={childRef} className={className}>
        <TextWrapper>
          <Header>
            <Heading theme={this.context}>{heading}</Heading>
            <Title theme={this.context}>{title}</Title>
          </Header>
          <Article>
            <Paragraph1 theme={this.context}>{paragraph1}</Paragraph1>
            <Paragraph2 theme={this.context}>{paragraph2}</Paragraph2>
          </Article>
        </TextWrapper>
        <AwardsWrapper>
          {awardsSorted.map((award) => (
            <AwardCounter key={award.name} award={award} count={award.count} />
          ))}
        </AwardsWrapper>
      </Wrapper>
    );
  }
}
